var path = '/assets/js/dashboard/financials/cashflow/cashflow.html';
var html = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <arbitrary-splits company=\"$ctrl.company\"></arbitrary-splits>\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;